import { createContext, FunctionComponent, useContext } from 'react';
import { useConnect } from 'wagmi';

// import { InjectedConnector } from 'wagmi/connectors/injected';
// import { useGetNFTBalance } from '~/hooks/mint/useGetNFTBalance';
// import { useGetRemainingNFTs } from '~/hooks/mint/useGetRemainingNFTs';
// import { useMintNFT } from '~/hooks/mint/useMintNFT';
// import { useCheckWeb3APIInstalled } from '~/hooks/web3/useCheckWeb3APIInstalled';
// import { useConnectWallet } from '~/hooks/web3/useConnectWallet';
// import { useConnectWallet } from '~/hooks/web3/useConnectWallet';
import { useGetAccount } from '~/hooks/web3/useGetAccount';

import {
  ConnectedWalletProviderProps,
  ConnectedWalletProviderValues,
  // Web3Error,
} from './ConnectedWalletProvider.types';

const ConnectedWalletContext = createContext(
  {} as ConnectedWalletProviderValues
);

const ConnectedWalletProvider: FunctionComponent<
  ConnectedWalletProviderProps
> = ({ children }) => {
  // const { address, isConnecting, isConnected } = useAccount();
  const { connect: connectAccount, error: connectAccountError } = useConnect();
  const { data: account, isLoading } = useGetAccount();

  // const { isLoading: accountsAreLoading, data: connectedAccount } =
  //   useGetAccount();
  // const { isInstalled: web3APIIsInstalled } = useCheckWeb3APIInstalled();
  // const { data: ensName, isLoading } = useEnsName({ address });
  // const { mutate: connectAccount, error: connectAccountError } =
  //   useConnectWallet();

  // const walletIsConnected =
  //   connectedAccount !== undefined && connectedAccount.connected;
  // const address = connectedAccount?.address;

  // const account = {
  //   address: address,
  //   ensName: ensName,
  //   isValidNetwork: true, // TODO!
  // };
  return (
    <ConnectedWalletContext.Provider
      value={{
        connectAccount,
        connectAccountError: connectAccountError as Error,
        isLoading,
        account: account,
        // web3APIIsInstalled,
        walletIsConnected: account?.connected || false,
      }}
    >
      {children}
    </ConnectedWalletContext.Provider>
  );
};

export default ConnectedWalletProvider;

export function useConnectedWallet(): ConnectedWalletProviderValues {
  return useContext(ConnectedWalletContext);
}
